import React from 'react'

const React_Coding_Practice_7 = () => {
  return (
    <div>
      <h1>Coding Pratice 7</h1>
    </div>
  )
}

export default React_Coding_Practice_7
